<!--eslint-disable max-lines-->
<template>
  <div>
    <b-card>
      <b-card-header class="cardHeader"
        >{{ $t("ui.dangersignTtile") }}
      </b-card-header>
      <Map v-bind:title="$t('dangerSign.label.location')" />
      <Date v-bind:dateLabel="$t('dangerSign.label.date')" />
      <Document v-bind:commentLabel="$t('dangerSign.label.comment')" />
      <label style="margin-top: 10px; font-weight: bold">
        {{ $t("dangerSign.dangerSign") }}
      </label>
      <b-row cols="1" cols-sm="1" cols-md="3" class="inputFormRow">
        <b-col>
          <label for="whumpfCracksFrequency"
            >{{ $t("dangerSign.label.whumpfCracksFrequency") }}
          </label>
          <b-form-select
            id="whumpfCracksFrequency"
            v-model="selectedWhumpfCracksFrequency"
            :options="frequency"
          />
        </b-col>
        <b-col>
          <label for="snowdriftSize">
            {{ $t("dangerSign.label.snowdriftSize") }}
          </label>
          <b-form-select
            id="snowdriftSize"
            v-model="selectedSnowdriftSize"
            :options="snowdriftsize"
          />
        </b-col>
      </b-row>
      <hr />
      <label style="margin-top: 10px; font-weight: bold">
        {{ $t("dangerSign.avalancheDanger") }}
      </label>
      <b-row cols="1" cols-sm="1" cols-md="2" class="inputFormRow">
        <b-col>
          <label for="dangerOf">
            {{ $t("dangerSign.label.dangerOf") }}
          </label>
          <b-form-select
            id="dangerOf"
            v-model="selectedDangerOf"
            :options="dangerOf"
          />
        </b-col>
      </b-row>

      <b-row cols="1" cols-sm="1" cols-md="4" class="inputFormRow">
        <b-col>
          <b-form-group>
            <label for="dangerAspectFromInput">
              {{ $t("dangerSign.label.aspectFrom") }}
            </label>
            <b-form-select
              id="dangerAspectFromInput"
              v-model="aspectFrom"
              :options="aspect"
              :state="isAspectValid || aspectFrom ? null : false"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <label for="dangerAspectToInput">
              {{ $t("dangerSign.label.aspectTo") }}
            </label>
            <b-form-select
              id="dangerAspectToInput"
              v-model="aspectTo"
              :options="aspect"
              :state="isAspectValid || aspectTo ? null : false"
            />
          </b-form-group>
        </b-col>
        <b-col lg="6">
          <b-form-group>
            <b-col md="3" cols="10" offset="1">
              <eurose :aspects="selectedAspects"></eurose>
            </b-col>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row cols="1" cols-sm="1" cols-md="2" class="inputFormRow">
        <b-col>
          <label for="altitudeAbove"
            >{{ $t("dangerSign.label.altitudeAbove") }}
          </label>
          <b-form-select
            id="altitudeAbove"
            v-model="selectedAltitudeAbove"
            :options="altitudeAbove"
            :state="
              isAltitudeValid || selectedAltitudeAbove != null ? null : false
            "
          />
        </b-col>
        <b-col>
          <label for="altitude">
            {{ $t("dangerSign.label.altitude") }}
          </label>
          <b-form-select
            id="altitude"
            v-model="selectedAltitude"
            :options="height"
            :state="isAltitudeValid || selectedAltitude != null ? null : false"
          />
        </b-col>
      </b-row>

      <b-row cols="1" cols-sm="1" cols-md="2" class="inputFormRow">
        <b-col>
          <label for="level"> {{ $t("dangerSign.label.level") }} </label>
          <b-form-select id="level" v-model="selectedLevel" :options="level" />
        </b-col>
      </b-row>

      <div>
        <b-button
          class="mapButton"
          type="submit"
          :variant="isValid ? 'outline-success' : 'outline-danger'"
          :disabled="!isValid"
        >
          {{ $t("ui.sendObservation") }}
        </b-button>
        <div class="divider" />
        <b-button class="mapButton" variant="outline-danger" @click="cancel">
          {{ $t("ui.cancel") }}
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import Document from "../common/Document.vue";
import Date from "../common/Date.vue";
import Map from "../common/Map.vue";
import store from "@/store/store.js";
import { i18nMixin, enums } from "@/I18N";
import Eurose from "@/components/eurose/WindEurose.vue";

const aspectMapper = {
  N: "N",
  NE: "NE",
  E: "E",
  SE: "SE",
  S: "S",
  SW: "SW",
  W: "W",
  NW: "NW",
};

export default {
  name: "DangerSign",
  components: {
    Document,
    Map,
    Date,
    Eurose,
  },
  mixins: [i18nMixin],
  data() {
    return {
      selectedAspects: [],
    };
  },
  computed: {
    height() {
      return [
        { value: null, text: this.$t("ui.select") },
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600,
        1700,
        1800,
        1900,
        2000,
        2100,
        2200,
        2300,
        2400,
        2500,
        2600,
        2700,
        2800,
        2900,
        3000,
        3100,
        3200,
        3300,
        3400,
        3500,
        3600,
        3700,
        3800,
        3900,
        4000,
        4100,
        4200,
      ];
    },
    frequency() {
      return this.options("dangerSign", "frequency");
    },
    snowdriftsize() {
      return this.options("dangerSign", "snowdriftSize");
    },
    dangerOf() {
      return this.options("dangerSign", "dangerOf");
    },
    altitudeAbove() {
      return this.options("dangerSign", "altitudeAbove");
    },
    level() {
      return this.options("dangerSign", "level");
    },
    aspect() {
      return this.options("common", "aspect");
    },
    aspectFrom: {
      get() {
        return store.ObservationData.getAspectFrom();
      },
      set(aspect) {
        store.ObservationData.setAspectFrom(aspect);
      },
    },
    aspectTo: {
      get() {
        return store.ObservationData.getAspectTo();
      },
      set(aspect) {
        store.ObservationData.setAspectTo(aspect);
      },
    },
    selectedSnowdriftSize: {
      get() {
        return store.ObservationData.getSnowdriftSize();
      },
      set(snowdriftSize) {
        store.ObservationData.setSnowdriftSize(snowdriftSize);
      },
    },
    selectedWhumpfCracksFrequency: {
      get() {
        return store.ObservationData.getWhumpfCracksFrequency();
      },
      set(whumpfCracksFrequency) {
        store.ObservationData.setWhumpfCracksFrequency(whumpfCracksFrequency);
      },
    },
    selectedDangerOf: {
      get() {
        return store.ObservationData.getDangerOf();
      },
      set(dangerOf) {
        store.ObservationData.setDangerOf(dangerOf);
      },
    },
    selectedAltitudeAbove: {
      get() {
        return store.ObservationData.getAltitudeAbove();
      },
      set(altitudeAbove) {
        store.ObservationData.setAltitudeAbove(altitudeAbove);
      },
    },
    selectedAltitude: {
      get() {
        return store.ObservationData.getAltitude();
      },
      set(altitude) {
        store.ObservationData.setAltitude(altitude);
      },
    },
    selectedLevel: {
      get() {
        return store.ObservationData.getLevel();
      },
      set(level) {
        store.ObservationData.setLevel(level);
      },
    },
    isAspectValid() {
      return store.ObservationData.isAspectValid();
    },
    isAltitudeValid() {
      return store.ObservationData.isAltitudeValid();
    },
    isValid() {
      return store.isValid() && store.isMinimalObservationContentSet();
    },
  },
  watch: {
    aspectFrom: function (newValue) {
      if (newValue && this.aspectTo) {
        this.changeAspects(newValue, this.aspectTo);
      } else {
        this.selectedAspects = [];
      }
    },
    aspectTo: function (newValue) {
      if (newValue && this.aspectFrom) {
        this.changeAspects(this.aspectFrom, newValue);
      } else {
        this.selectedAspects = [];
      }
    },
  },
  methods: {
    changeAspects(fromValue, toValue) {
      const dangerAspects = enums.common.aspect;
      const from = dangerAspects.indexOf(fromValue);
      const to = dangerAspects.indexOf(toValue);
      if (from === to) {
        this.selectedAspects = dangerAspects.map(
          (aspect) => aspectMapper[aspect]
        );
      } else {
        if (to < from) {
          this.selectedAspects = dangerAspects.filter(
            (aspect, i) => i >= from || i <= to
          );
        } else {
          this.selectedAspects = dangerAspects.filter(
            (aspect, i) => i >= from && i <= to
          );
        }
      }
    },
    cancel() {
      store.setCancelAlert(true);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
